import {
  ThemeProvider,
  Typography,
  useTheme
} from "@mui/material";
import { PaintMarker, PaintPolygon } from "../mapa";
import {
  divIcon,
  LatLng,
  LatLngExpression,
  Marker,
  Polygon
} from "leaflet";

import sirene from "../../assets/sirene.png";

export interface SireneData {
  id: number;
  idZas: number;
  lat: number;
  lon: number;
  dataInstalacao?: Date;
  municipio: number;
  idUpdate?: string;
  idModificou: string;
  dataCadastro: Date;
  dataModificacao?: Date;
  areaCobertura?: AreaSirene;
}

export class Sirene extends Marker<SireneData> {
  public style?: PaintMarker;
  public properties: SireneData;

  constructor(latLng: LatLng, properties: SireneData, style?: PaintMarker) {
    super(latLng, style);

    this.properties = properties;
    this.style = style;

    const iconSize = this.style?.iconSize ?? 20;
    
    this.setIcon(
      divIcon({
        html: this.iconComponent(),
        className: "",
        iconAnchor: [iconSize / 2, iconSize / 2],
      })
    );

    if (this.style && this.style.bindPopUp) {
      this.bindPopup(this.popUpComponent(), {
        className: "",
        maxWidth: 390,
      });
    }
    if (this.style && this.style.bindTooltip) {
      this.bindTooltip(this.tooltipComponent(), { direction: "top" });
    }
  }

  public iconComponent() {
    const component: JSX.Element = (<IconData
      iconSize={this.style?.iconSize ?? 15}
      text={'Sirene'}
    />
    );
    return window.JSXToHTML(component);
  }

  public popUpComponent() {
    return window.JSXToHTML(
      <div style={{
        display: "flex",
        flexDirection: "column",
        justifyItems: "center",
        height: "10em",
        width: "19em",
        overflowY: "auto",
      }}>
        <Typography fontSize={"1.2em"} fontWeight={"bold"}>
          Sirene
        </Typography>
      </div>
    );
  }

  public tooltipComponent() {
    return window.JSXToHTML(
      <div style={{
        display: "flex",
        flexDirection: "column",
        justifyItems: "center",
        overflowY: "auto",
      }}>
        <Typography fontSize={"1.2em"} fontWeight={"bold"}>
          Sirene
        </Typography>
      </div>
    );
  }
}

interface PropsIcon {
  text: string;
  iconSize: number;
}

const IconData: React.FC<PropsIcon> = ({ iconSize, text }) => {
  const theme = useTheme();

  return <ThemeProvider theme={theme}>
    <img
      src={sirene}
      alt={text}
      style={{
        objectFit: "contain",
        height: `${iconSize}px`,
        width: `${iconSize}px`,
      }}
    />
  </ThemeProvider>;
};

export class AreaSirene extends Polygon {
  public style?: PaintPolygon;

  constructor(
    geometries: LatLngExpression[] | LatLngExpression[][] | LatLngExpression[][][],
    style?: PaintPolygon
  ) {

    super(geometries, style);

    this.style = style;

    if (this.style && this.style.bindPopUp) {
      this.bindPopup(this.popUpComponent(), {
        className: "",
        maxWidth: 390,
      });
    }
    if (this.style && this.style.bindTooltip) {
      this.bindTooltip(this.tooltipComponent(), { direction: "top" });
    }
  }

  public popUpComponent() {
    return window.JSXToHTML(
      <div style={{
        display: "flex",
        flexDirection: "column",
        justifyItems: "center",
        height: "10em",
        width: "19em",
        overflowY: "auto",
      }}>
        <Typography fontSize={"1.2em"} fontWeight={"bold"}>
          Sirene
        </Typography>
      </div>
    );
  }

  public tooltipComponent() {
    return window.JSXToHTML(
      <div style={{
        display: "flex",
        flexDirection: "column",
        justifyItems: "center",
        overflowY: "auto",
      }}>
        <Typography fontSize={"1.2em"} fontWeight={"bold"}>
          Sirene
        </Typography>
      </div>
    );
  }
}